/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './search-facets.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/utils.service';
import * as import9 from '@angular/router/src/router_state';
import * as import10 from '@angular/router/src/router';
import * as import11 from '../shared/search-elasticsearch.service';
import * as import12 from '@angular/core/src/metadata/view';
import * as import13 from '@angular/core/src/linker/component_factory';
import * as import14 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import15 from '../shared/truncate.pipe';
import * as import16 from '@angular/core/src/linker/template_ref';
import * as import17 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import18 from '@angular/common/src/directives/ng_for';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '@angular/common/src/directives/ng_if';
export class Wrapper_SearchFacetsComponent {
  context:import0.SearchFacetsComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this.changed = false;
    this.context = new import0.SearchFacetsComponent(p0,p1,p2,p3);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
  }
  check_esAggregations(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.esAggregations = currValue;
      this._expr_0 = currValue;
    }
  }
  check_fields(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.fields = currValue;
      this._expr_1 = currValue;
    }
  }
  check_esFilters(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.esFilters = currValue;
      this._expr_2 = currValue;
    }
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_3 = currValue;
    }
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_4 = currValue;
    }
  }
  check_target(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this.changed = true;
      this.context.target = currValue;
      this._expr_5 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_SearchFacetsComponent_Host:import4.RenderComponentType = (null as any);
class _View_SearchFacetsComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _SearchFacetsComponent_0_4:Wrapper_SearchFacetsComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent_Host0,renderType_SearchFacetsComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'search-facets',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_SearchFacetsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchFacetsComponent_0_4 = new Wrapper_SearchFacetsComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import9.ActivatedRoute),this.parentInjector.get(import10.Router),this.parentInjector.get(import11.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._SearchFacetsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchFacetsComponent) && (0 === requestNodeIndex))) { return this._SearchFacetsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchFacetsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFacetsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_SearchFacetsComponent_Host === (null as any))) { (renderType_SearchFacetsComponent_Host = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_SearchFacetsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const SearchFacetsComponentNgFactory:import13.ComponentFactory<import0.SearchFacetsComponent> = new import13.ComponentFactory<import0.SearchFacetsComponent>('search-facets',viewFactory_SearchFacetsComponent_Host0,import0.SearchFacetsComponent);
const styles_SearchFacetsComponent:any[] = ([] as any[]);
var renderType_SearchFacetsComponent:import4.RenderComponentType = (null as any);
class _View_SearchFacetsComponent0 extends import3.AppView<import0.SearchFacetsComponent> {
  _text_0:any;
  _anchor_1:any;
  /*private*/ _appEl_1:import5.AppElement;
  _TemplateRef_1_5:any;
  _NgFor_1_6:import14.Wrapper_NgFor;
  _pipe_truncate_0:import15.TruncatePipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent0,renderType_SearchFacetsComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_1 = new import5.AppElement(1,(null as any),this,this._anchor_1);
    this._TemplateRef_1_5 = new import16.TemplateRef_(this._appEl_1,viewFactory_SearchFacetsComponent1);
    this._NgFor_1_6 = new import14.Wrapper_NgFor(this._appEl_1.vcRef,this._TemplateRef_1_5,this.parentInjector.get(import17.IterableDiffers),this.ref);
    this._pipe_truncate_0 = new import15.TruncatePipe();
    this.init(([] as any[]),[
      this._text_0,
      this._anchor_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.TemplateRef) && (1 === requestNodeIndex))) { return this._TemplateRef_1_5; }
    if (((token === import18.NgFor) && (1 === requestNodeIndex))) { return this._NgFor_1_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.context.fields;
    this._NgFor_1_6.check_ngForOf(currVal_1_0_0,throwOnChange,false);
    this._NgFor_1_6.detectChangesInInputProps(this,this._anchor_1,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_SearchFacetsComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.SearchFacetsComponent> {
  if ((renderType_SearchFacetsComponent === (null as any))) { (renderType_SearchFacetsComponent = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.None,styles_SearchFacetsComponent,{})); }
  return new _View_SearchFacetsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import19.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent1,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','facet widget'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2,viewFactory_SearchFacetsComponent2);
    this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import20.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.parent.context.esAggregations && (this.parent.context.esAggregations[this.context.$implicit].buckets.length > 0));
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import19.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import5.AppElement;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import19.Wrapper_NgIf;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import5.AppElement;
  _TemplateRef_10_5:any;
  _NgFor_10_6:import14.Wrapper_NgFor;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent2,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2,viewFactory_SearchFacetsComponent3);
    this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_4 = new import5.AppElement(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import16.TemplateRef_(this._appEl_4,viewFactory_SearchFacetsComponent4);
    this._NgIf_4_6 = new import19.Wrapper_NgIf(this._appEl_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','widget-body'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_6,'ul',new import2.InlineArray2(2,'class','category-list'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._appEl_10 = new import5.AppElement(10,8,this,this._anchor_10);
    this._TemplateRef_10_5 = new import16.TemplateRef_(this._appEl_10,viewFactory_SearchFacetsComponent5);
    this._NgFor_10_6 = new import14.Wrapper_NgFor(this._appEl_10.vcRef,this._TemplateRef_10_5,this.parent.parentInjector.get(import17.IterableDiffers),this.parent.parent.ref);
    this._text_11 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import20.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import16.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import20.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import16.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import18.NgFor) && (10 === requestNodeIndex))) { return this._NgFor_10_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.parent.context.$implicit != 'type');
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = (this.parent.context.$implicit != 'type');
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    const currVal_10_0_0:any = this.parent.parent.context.esAggregations[this.parent.context.$implicit].buckets;
    this._NgFor_10_6.check_ngForOf(currVal_10_0_0,throwOnChange,false);
    this._NgFor_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent3,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'h5',new import2.InlineArray2(2,'class','widget-title font-alt'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = import2.interpolate(1,'',((this.parent.parent.parent.context.labels && this.parent.parent.parent.context.labels[this.parent.parent.context.$implicit])? this.parent.parent.parent.context.labels[this.parent.parent.context.$implicit][this.parent.parent.parent.context.language]: this.parent.parent.context.$implicit),'');
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent4 extends import3.AppView<any> {
  _el_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent4,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','thin-separator-line bg-dark-gray no-margin-lr margin-ten'),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_SearchFacetsComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent5 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import19.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import5.AppElement;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import19.Wrapper_NgIf;
  _text_5:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent5,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',new import2.InlineArray2(2,'class','facet-element'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2,viewFactory_SearchFacetsComponent6);
    this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_4 = new import5.AppElement(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import16.TemplateRef_(this._appEl_4,viewFactory_SearchFacetsComponent7);
    this._NgIf_4_6 = new import19.Wrapper_NgIf(this._appEl_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import20.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import16.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import20.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:boolean = !this.parent.parent.parent.context.utils.isInFilters(this.parent.parent.parent.context.esFilters,this.parent.parent.context.$implicit,this.context.$implicit.key);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = this.parent.parent.parent.context.utils.isInFilters(this.parent.parent.parent.context.esFilters,this.parent.parent.context.$implicit,this.context.$implicit.key);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent5(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent6 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_truncate_0_0:any;
  /*private*/ _expr_7:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent6,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'a',new import2.InlineArray2(2,'style','cursor: pointer'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this._pipe_truncate_0_0 = import2.pureProxy2((<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0.transform.bind((<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import2.interpolate(1,'\n                    ',valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_0,(<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0.transform)((((this.parent.parent.parent.parent.context.labels && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES) && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key])? this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key][this.parent.parent.parent.parent.context.language]: this.parent.context.$implicit.key),'20')),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
    const currVal_7:any = import2.interpolate(1,'',this.parent.context.$implicit.doc_count,'');
    if (import2.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_3,currVal_7);
      this._expr_7 = currVal_7;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.parent.parent.context.onSelect(this.parent.parent.parent.context.$implicit,this.parent.context.$implicit.key)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_SearchFacetsComponent6(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFacetsComponent7 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_truncate_0_1:any;
  /*private*/ _expr_7:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFacetsComponent7,renderType_SearchFacetsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'a',new import2.InlineArray2(2,'class','facet-active'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_truncate_0_1 = import2.pureProxy2((<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0.transform.bind((<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import2.interpolate(1,'\n                    ',valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_1,(<_View_SearchFacetsComponent0>this.parent.parent.parent.parent)._pipe_truncate_0.transform)((((this.parent.parent.parent.parent.context.labels && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES) && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key])? this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key][this.parent.parent.parent.parent.context.language]: this.parent.context.$implicit.key),'20')),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
    const currVal_7:any = import2.interpolate(1,'',this.parent.context.$implicit.doc_count,'');
    if (import2.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_3,currVal_7);
      this._expr_7 = currVal_7;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFacetsComponent7(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFacetsComponent7(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/search-facets.component.ngfactory.ts